import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
const BANNER_IMAGE = 'https://cdn.magicpatterns.com/uploads/2g6TwprbMpdDwTZDMvUwzK/ChatGPT_Image_Aug_16,_2026,_12_09_58_AM.png';
const MOUNTAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wKy5wTQ9caLQgtnJUX6gAj/philipp-jW6ZpBFE9dE-unsplash.jpg';
const BANNER_IMAGE_PORTRAIT = 'https://cdn.magicpatterns.com/uploads/1fy1dY1BXigxSTVkt42etx/ChatGPT_Image_Aug_16,_2026,_03_40_45_PM.png';

/** Fono spalva, paimta iš banerio nuotraukos kremo atspalvio */
const BANNER_BG = '#F8F3EE';

/** Minkšti kraštai, kad nuotrauka susilietų su fonu */
const MASK_WIDE = 'radial-gradient(115% 105% at 50% 42%, #000 55%, rgba(0,0,0,0.65) 78%, transparent 100%)';
const MASK_PORTRAIT = 'linear-gradient(to bottom, #000 78%, rgba(0,0,0,0.55) 92%, transparent 100%)';
const SLIDES = [{
  id: 'banner',
  label: 'Savireguliacijos efektas',
  dark: false,
  duration: 35000
}, {
  id: 'mountain',
  label: 'Tavo dėmesys',
  dark: true,
  duration: 12000
}];
const ease = [0.23, 1, 0.32, 1] as [number, number, number, number];
export function HeroRotator({
  onToneChange
}: {
  onToneChange?: (dark: boolean) => void;
}) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const reduceMotion = useReducedMotion();
  const active = SLIDES[index];
  useEffect(() => {
    onToneChange?.(active.dark);
  }, [active.dark, onToneChange]);
  useEffect(() => {
    if (paused) return;
    const timer = window.setTimeout(() => setIndex(i => (i + 1) % SLIDES.length), active.duration);
    return () => window.clearTimeout(timer);
  }, [index, paused, active.duration]);
  return <section className="relative overflow-hidden" style={{
    background: BANNER_BG
  }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} onFocus={() => setPaused(true)} onBlur={() => setPaused(false)} aria-roledescription="carousel" aria-label="Pagrindiniai kurso pristatymai" data-id="element-47" data-mp="1evz0vlk5fd3">
      <div className="relative h-[calc(100vh-4rem)] min-h-[560px] mt-16" data-id="element-48" data-mp="2sklj4ambboil">
        <AnimatePresence initial={false} mode="sync" data-id="element-49" data-mp="2dovr9vug4h5y">
          <motion.div key={active.id} className="absolute inset-0" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: reduceMotion ? 0 : 0.3,
          ease: 'easeOut'
        }} role="group" aria-label={`${index + 1} iš ${SLIDES.length}: ${active.label}`} data-id="element-50" data-mp="2do49bntruhy5">
            {active.id === 'banner' ? <BannerSlide data-id="element-51" data-mp="1lxg4a0oz8sf7" /> : <MountainSlide data-id="element-52" data-mp="1lwy2ypngjo0f" />}
          </motion.div>
        </AnimatePresence>

        {/* Dots */}
        <div className="absolute bottom-24 md:bottom-28 left-0 right-0 z-40 flex justify-center gap-2.5" data-id="element-53" data-mp="1pz1gdjtot2oc">
          {SLIDES.map((slide, i) => {
          const selected = i === index;
          return <button key={slide.id} onClick={() => setIndex(i)} aria-label={`Rodyti: ${slide.label}`} aria-current={selected} className="rounded-full transition-colors duration-200" style={{
            width: selected ? 28 : 10,
            height: 10,
            background: active.dark ? selected ? '#FFFFFF' : 'rgba(255,255,255,0.45)' : selected ? '#1B1B4B' : 'rgba(27,27,75,0.25)'
          }} data-id="element-54" data-mp="12cfwvtnzqet8" data-mpi={i} />;
        })}
        </div>
      </div>

      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 right-0 z-30 translate-y-[1px] pointer-events-none" data-id="element-55" data-mp="28xiaeneq3vcl">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full block" preserveAspectRatio="none" data-id="element-56" data-mp="23yx7gg836xkg">
          <path d="M0 0C240 80 480 80 720 40C960 0 1200 0 1440 40V120H0V0Z" style={{
          fill: 'rgb(var(--sand-light))'
        }} data-id="element-57" data-mp="2s23kep8dyecm" />
        </svg>
      </div>
    </section>;
}

/* ── 1. Banerio skaidrė ── */
function BannerSlide() {
  return <div className="relative w-full h-full flex flex-col items-center justify-end" style={{
    background: BANNER_BG
  }} data-id="element-58" data-mp="2563dlsoecxlg">
      {/* Telefonui — vertikalus variantas */}
      <img src={BANNER_IMAGE_PORTRAIT} alt="Savireguliacijos efektas — sąmoningumas gyvenimo situacijose su Agne ir Vestina. Pradžia 09.21, gyvi mokymai, Vilnius." className="md:hidden absolute inset-0 w-full h-full object-cover object-top select-none" style={{
      maskImage: MASK_PORTRAIT,
      WebkitMaskImage: MASK_PORTRAIT
    }} data-id="element-59" data-mp="2e6rqgk220rwr" />
      {/* Planšetei / kompiuteriui — platus variantas */}
      <img src={BANNER_IMAGE} alt="" aria-hidden="true" className="hidden md:block absolute left-0 right-0 top-0 w-full max-h-[calc(100%-9rem)] object-contain object-top select-none" style={{
      maskImage: MASK_WIDE,
      WebkitMaskImage: MASK_WIDE
    }} data-id="element-60" data-mp="1dw8ieez88u40" />
      <motion.a href="#apie" whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.15,
      ease
    }} className="relative z-10 text-white px-11 py-[15px] rounded-full text-base font-semibold shadow-xl inline-block mb-32 md:mb-36" style={{
      background: '#1B1B4B'
    }} data-id="element-61" data-mp="105vaudq8zhf7">
        Sužinok Daugiau
      </motion.a>
    </div>;
}

/* ── 2. Kalnų skaidrė (ankstesnis viršelis) ── */
function MountainSlide() {
  return <div className="relative w-full h-full flex flex-col items-center justify-end px-4" data-id="element-62" data-mp="dw6jdekmgqw7">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url('${MOUNTAIN_IMAGE}')`
    }} data-id="element-63" data-mp="inwuvnvapkp7" />
      <div className="relative z-20 max-w-4xl mx-auto text-center flex flex-col items-center flex-1 justify-center pt-8" data-id="element-64" data-mp="40bpfnay79e4">
        <h1 className="text-4xl md:text-6xl lg:text-7xl mb-6 leading-tight text-white font-semibold" style={{
        textShadow: '0 1px 3px rgba(0,0,0,0.6), 0 4px 12px rgba(0,0,0,0.3), 0 8px 30px rgba(0,0,0,0.15)'
      }} data-id="element-65" data-mp="wn6aomflacsn">
          Tavo Dėmesys Yra Brangiausias Tavo Resursas
        </h1>
        <p className="text-lg md:text-xl text-white/85 mb-10 max-w-2xl mx-auto leading-relaxed font-[300]" style={{
        textShadow: '0 1px 2px rgba(0,0,0,0.5), 0 3px 10px rgba(0,0,0,0.25)'
      }} data-id="element-66" data-mp="rn1pij3qktw3">
          Tavo energija keliauja ten, kur nukreipi savo dėmesį. Treniruok jį ir
          stebėk, kaip keičiasi tavo vidinė būsena ir produktyvumas.
        </p>
      </div>

      {/* Mygtukas toje pačioje vietoje kaip 1-oje skaidrėje */}
      <motion.a href="#apie" whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.15,
      ease
    }} className="relative z-20 bg-white text-mountain-darker px-11 py-[15px] rounded-full text-base font-semibold shadow-2xl inline-block mb-32 md:mb-36" data-id="element-67" data-mp="3erxo1beiu0bv">
        Sužinok Daugiau
      </motion.a>
    </div>;
}